import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfirmPopup',
  props: {
    isLoading: {
      type: Boolean,
    },
    errorText: {
      type: String,
    },
    customText: {
      type: String,
    },
  },
  emits: ['agree', 'cancel'],
  setup() {
    return {}
  },
})
